import { render, staticRenderFns } from "./CustomCheckbox.vue?vue&type=template&id=22b38af8&scoped=true&"
import script from "./CustomCheckbox.vue?vue&type=script&lang=js&"
export * from "./CustomCheckbox.vue?vue&type=script&lang=js&"
import style0 from "./CustomCheckbox.vue?vue&type=style&index=0&id=22b38af8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "22b38af8",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/tgs-automation/tgs-automation/mojaweb/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('22b38af8')) {
      api.createRecord('22b38af8', component.options)
    } else {
      api.reload('22b38af8', component.options)
    }
    module.hot.accept("./CustomCheckbox.vue?vue&type=template&id=22b38af8&scoped=true&", function () {
      api.rerender('22b38af8', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/Forms/CustomCheckbox.vue"
export default component.exports